import { XClose } from "@untitled-ui/icons-react";
import React, { ReactElement } from "react";
import styles from "./dialogCloseButton.module.scss";
import classNames from "classnames";

export const DialogCloseButton = (
  props: React.ComponentPropsWithoutRef<"button">,
): ReactElement => {
  return (
    <button
      {...props}
      className={classNames(styles.close, styles.closePosition)}
    >
      <XClose />
    </button>
  );
};
